<div class="scrim" #scrimEl [class.show]="expanded()" (click)="collapse()"></div>

<section
  class="sheet"
  #sheetEl
  [class.expanded]="expanded()"
  role="dialog"
  aria-label="Online players"
  (click)="onSheetClick($event)"
>
  <div class="grab" (pointerdown)="sheetDrag.start($event)">
    <div class="handle" aria-hidden="true"></div>
    <header class="sheet-head">
      <span class="sheet-title ui-label">{{ onlineCount() }} players online</span>
      @if (!expanded()) {
        <span class="head-avatars" aria-hidden="true">
          @for (addr of headAvatars(); track addr) {
            <app-pixel-creature [addr]="addr" [size]="20" />
          }
        </span>
      }
    </header>
  </div>

  <div class="body">
    @for (entry of otherPlayers(); track entry.address) {
      <app-online-player-row
        [address]="entry.address"
        [player]="entry.user"
        [expanded]="openAddress() === entry.address"
        [defaultMode]="defaultMode()"
        [pendingAddress]="challengePending()"
        (toggle)="toggleRow(entry.address)"
        (challenge)="challenge.emit($event)"
      ></app-online-player-row>
    }
  </div>
</section>
